module.exports = __webpack_public_path__ + "img/BULB.77c55c40.png";